import React, { useState, useEffect, useCallback } from 'react';
import { adminListUsers, getPlatformStats } from '../../utils/api';
import Pagination from '../Pagination';
import CopyButton from '../CopyButton';

const UserManagement = ({ vBC, onImpersonate }) => {
  const [stats, setStats] = useState(null);
  const [users, setUsers] = useState([]);
  const [pagination, setPagination] = useState({ total: 0, page: 1, pages: 1 });
  const [search, setSearch] = useState('');
  const [searchInput, setSearchInput] = useState('');
  const [loading, setLoading] = useState(false);

  const tr = (a) => a ? `${a.slice(0, 6)}...${a.slice(-4)}` : '';

  const loadUsers = useCallback(async (q = '', pg = 1) => {
    setLoading(true);
    try {
      const [u, s] = await Promise.all([adminListUsers(q, pg, 20), getPlatformStats()]);
      setUsers(u.users); setPagination(u.pagination); setStats(s.stats);
    } catch {} setLoading(false);
  }, []);

  useEffect(() => { loadUsers(); }, [loadUsers]);

  const doSearch = () => { setSearch(searchInput); loadUsers(searchInput, 1); };

  return (
    <div className="fade-in">
      <h2 className="adm-title">Users</h2>
      {stats && (
        <div className="adm-kpi-grid">
          {[['Total', stats.totalUsers], ['Today', stats.todayUsers], ['Week', stats.weekUsers], ['Buys', stats.buyCount], ['Sells', stats.sellCount]].map(([l, v]) => (
            <div key={l} className="adm-kpi card"><span className="adm-kpi-label">{l}</span><strong className="adm-kpi-val mono">{v}</strong></div>
          ))}
        </div>
      )}
      <div className="adm-user-search">
        <input className="input" placeholder="Search referral code, wallet..." value={searchInput} onChange={e => setSearchInput(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') doSearch(); }} />
        <button className="btn btn-primary" onClick={doSearch}>Search</button>
        {search && <button className="btn btn-outline btn-sm" onClick={() => { setSearchInput(''); setSearch(''); loadUsers('', 1); }}>Clear</button>}
      </div>
      {loading ? <div className="page-loading"><div className="spinner" /></div> : (
        <>
          <div className="table-wrap"><table className="table">
            <thead><tr><th>Referral Code</th><th>Wallet</th><th>Sponsor ID</th><th>Invested</th><th>Buys</th><th>Registered</th><th></th></tr></thead>
            <tbody>{users.length > 0 ? users.map(u => (
              <tr key={u.roboId}><td className="mono"><span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>{u.referralCode}{u.referralCode && <CopyButton text={u.referralCode} title="Copy referral code" size={12} />}</span></td><td className="mono"><span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>{tr(u.walletAddress)}<CopyButton text={u.walletAddress} title="Copy wallet" size={12} /></span></td><td className="mono"><span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>{u.referredByCode || '—'}{u.referredByCode && <CopyButton text={u.referredByCode} title="Copy sponsor ID" size={12} />}</span></td><td className="mono">{vBC(u.totalInvestedUsdt || 0)}</td><td className="mono">{u.buyCount || 0}</td><td>{new Date(u.registeredAt).toLocaleString('en-US', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true })}</td><td>{onImpersonate && <button className="btn btn-outline btn-sm" onClick={() => onImpersonate(u.roboId)} title="Open this user's dashboard, read-only">View as User</button>}</td></tr>
            )) : <tr><td colSpan="7" className="text-3" style={{textAlign:'center'}}>No users</td></tr>}</tbody>
          </table></div>
          <Pagination
            page={pagination.page}
            pages={pagination.pages}
            total={pagination.total}
            perPage={20}
            onPage={(p) => loadUsers(search, p)}
          />
        </>
      )}
    </div>
  );
};

export default UserManagement;
